export default {
  appName: process.env.VUE_APP_NAME,
  appSlogan: process.env.VUE_APP_SLOGAN,
  appLinkWebsite: process.env.VUE_APP_LINK_WEBSITE,
  mock_api: process.env.VUE_APP_MOCK_API === 'true',
  dateFormat: 'YYYY-MM-DD',
  dateTimeFormat: 'YYYY-MM-DD HH:mm',
  timeFormat: 'HH:mm',

  routeMiddleware: {
    AUTH: 'auth',
    GUEST: 'guest',
    VERIFY_TOKEN: 'verifyToken',
    CAN: 'can',
  },

  permissions: {
    ACCESS_CMS: 'app-cms',
  },

  statusColors: {
    initiated: 'info',
    created: 'success',
    delivered: 'warning',
    rejected: 'error',
  },

  auth: {
    driver: 'cookie',
    tokenName: 'token',
  },

  /**
   * @see https://github.com/js-cookie/js-cookie#cookie-attributes
   */
  cookie: {
    // 30 days
    expires: 30,
  },

  // data table options
  dataTable: {
    footerProps: {
      itemsPerPageOptions: [5, 10, 15, 20, 25, 50, 100],
    },
  },

  bannerTypes: [
    {
      text: 'Product Single',
      value: '1',
    },
    {
      text: 'Product Category',
      value: '2',
    },
    {
      text: 'Product Promotion',
      value: '3',
    },
    {
      text: 'Article',
      value: '4',
    },
    {
      text: 'URL',
      value: '5',
    },
  ],

  bannerFlags: [
    {
      text: 'Mobile',
      value: 'mobile',
    },
    {
      text: 'Web',
      value: 'web',
    },
    {
      text: 'Both',
      value: 'all',
    },
  ],
};
